module.exports = __webpack_public_path__ + "img/co-branding-logo-starbucks.9c8366f4.png";